// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__L3YhM","dot":"LoadingDots_dot__YIHAP","blink":"LoadingDots_blink__8sST9"};